import { __awaiter } from "tslib";
import { FacadeRegistry } from './facade-registry';
// Serialize the JwebInterfaceVersion to a JSON string
const serializeVersion = (version) => JSON.stringify(version);
// Define a feature rule for allowing binding fallback
const allowBindingFallbackRule = {
    name: 'allowBindingFallback',
    minimumVersion: { major: 5, minor: 11, patch: 0 },
    methods: ['filterCDMTrees', 'filterLEDMTrees', 'isDataAllowed'],
    handleCall({ featureName, minimumVersion, options, next, }) {
        var _a, _b;
        const allowBindingFallback = (_b = (_a = options === null || options === void 0 ? void 0 : options.filterOptions) === null || _a === void 0 ? void 0 : _a.allowBindingFallback) !== null && _b !== void 0 ? _b : options === null || options === void 0 ? void 0 : options.allowBindingFallback;
        if (allowBindingFallback === false) {
            const message = `${featureName} is not supported below interface version ${serializeVersion(minimumVersion)}.`;
            console.warn(`DataCollectionFacade::${featureName}: ${message}`);
            return Promise.reject(new Error(message));
        }
        return next(options);
    },
};
// Array to hold data collection feature rules
const dataCollectionFeatureRules = [
    allowBindingFallbackRule,
];
// Function to wrap methods in the DataCollectionPlugin with feature rules
const wrapMethod = (plugin, method, rule) => {
    const original = plugin[method];
    if (!original) {
        console.warn(`Method ${method} does not exist on plugin.`);
        return;
    }
    const boundOriginal = original.bind(plugin);
    plugin[method] = ((options) => rule.handleCall({
        featureName: rule.name,
        minimumVersion: rule.minimumVersion,
        method,
        options,
        next: (nextOptions) => boundOriginal(nextOptions),
    }));
};
// Facade function for data collection
export const dataCollectionFacade = (jWeb) => __awaiter(void 0, void 0, void 0, function* () {
    if (!jWeb.isPluginAvailable('DataCollection')) {
        return;
    }
    const dataCollectionPlugin = jWeb.Plugins.DataCollection;
    for (const rule of dataCollectionFeatureRules) {
        const supportsRule = yield FacadeRegistry.pluginSupportsInterfaceVersion(dataCollectionPlugin, 'DataCollection', rule.minimumVersion);
        if (supportsRule) {
            continue;
        }
        for (const method of rule.methods) {
            wrapMethod(dataCollectionPlugin, method, rule);
        }
    }
});
//# sourceMappingURL=dataCollectionFacade.js.map